<mat-sidenav-container [autofocus]="false">
  <div class="w-full h-full flex flex-col overflow-y-auto overflow-x-hidden items-left px-3 py-4 gap-3">
    <ng-container *ngIf="verified && !mustFinishPhone">
      <a matRipple *ngIf="userFullyRegistered === false" (click)="navigate('/manual-inscription/' + storeId)" class="flex items-center gap-3 rounded px-2 py-3 hover:shadow-lg hover:cursor-pointer">
        <div class="icon-wrapper flex justify-center items-center w-6 h-6">
          <mat-icon svgIcon="ph-regular-file-text" class="text-primary"></mat-icon>
        </div>
        <span class="text-primary text-lg leading-5 font-semibold">{{ 'components.sidebar.manual_inscription' | translate }}</span>
      </a>
      <ng-container *ngFor="let link of links; let last = last">
        <hr *ngIf="last" class="border-t border-border-gray my-2">
        <a matRipple (click)="link.action()"
           class="flex items-center gap-3 rounded px-2 py-3 hover:shadow-lg hover:cursor-pointer"
           [ngClass]="isActive(link.route) ? 'bg-default-light' : 'bg-transparent'">
          <div class="icon-wrapper flex justify-center items-center w-6 h-6">
            <mat-icon [svgIcon]="link.svgIcon" class="text-primary"></mat-icon>
          </div>
          <span class="text-primary text-lg leading-5 font-semibold">{{ link.title | translate }}</span>
        </a>
      </ng-container>
    </ng-container>
    <a matRipple (click)="logOut()" class="flex items-center gap-3 rounded px-2 py-3 hover:shadow-lg hover:cursor-pointer">
      <div class="logout-wrapper flex justify-center items-center w-6 h-6">
        <mat-icon svgIcon="ph-regular-sign-out" class="text-error"></mat-icon>
      </div>
      <span class="text-error text-lg leading-5 font-semibold">{{ 'components.sidebar.logout' | translate }}</span>
    </a>
  </div>
</mat-sidenav-container>
